import * as React from 'react';
import { Link } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import { Grid, TextField, Autocomplete, Container, Drawer, Paper, Avatar } from '@mui/material';
import spartaLogo from '../../../lease_management/assets/img/sparta_logo.svg';
import homeIcon from '../../../lease_management/assets/img/home_icon.svg';
import dashboardIcon from '../../../lease_management/assets/img/dashboard_icon.svg';
import assetIcon from '../../../lease_management/assets/img/asset_icon.svg';
import leasesIcon from '../../../lease_management/assets/img/leases_icon.svg';
import utilizationIcon from '../../../lease_management/assets/img/util_icon.svg';
import innvoicesIcon from '../../../lease_management/assets/img/invoices_icon.svg';
import cashflowsIcon from '../../../lease_management/assets/img/cashflows_icon.svg';
import reportsIcon from '../../../lease_management/assets/img/reports_icon.svg';
import settingIcon from "../../../lease_management/assets/img/setting_icon.svg";
const MobileHeader = () => {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  return (
    <div>
      <header className="mobile-header">
        <Container maxWidth={false}>
          <Grid container spacing={0} alignItems="center" justify="center">
            <Grid size={{ xs: 12 }}>
              <div style={{ display: 'flex' }}>
                <ul className='list-inline mobile-header-item'>
                  <li>
                    <MenuIcon onClick={toggleDrawer(true)} />
                  </li>
                  <li className="logo-right">
                    <Link to=''>
                      <img src={spartaLogo} alt="Sparta Logo" style={{ width: '35px', paddingLeft: '20px' }} />
                    </Link>
                  </li>
                </ul>
              </div>
            </Grid>
          </Grid>
        </Container>
      </header>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <div className="mobile-main-navs">
          <Paper className="user-info">
            <div className="user-card">
              <Avatar
                alt="Remy Sharp"
                src="/static/images/avatar/1.jpg"
                sx={{ width: 30, height: 30 }}
              />
              <span className='user'>
                <ul className="list-inline">
                  <li className='user-name'>Test User</li>
                  <li className='user-designation'>Test Designation</li>
                </ul>
              </span>
            </div>
            <Autocomplete
              disablePortal
              size="small"
              options={[]}
              sx={{ width: 250 }}
              renderInput={(params) => <TextField {...params} label="Lessor" />}
            />
          </Paper>
          <Paper className="mobile-pry-sidebar" elevation={0}>
            <div className='menu-link'>
              <Link to='' className="active">
                <img src={homeIcon} alt='Home' />
                <span>Home</span>
              </Link>
            </div>
            {/* <div className='menu-link'>
              <Link to=''>
                <img src={dashboardIcon} alt='Dashboard' />
                <span>Dashboard</span>
              </Link>
            </div> */}
            <div className='menu-link'>
              <Link to=''>
                <img src={assetIcon} alt='Assets' />
                <span>Assets</span>
              </Link>
            </div>
            <div className='menu-link'>
              <Link to=''>
                <img src={leasesIcon} alt='Leases' />
                <span>Leases</span>
              </Link>
            </div>
            <div className='menu-link'>
              <Link to=''>
                <img src={utilizationIcon} alt='Utilization' />
                <span>Utilization</span>
              </Link>
            </div>
            <div className='menu-link'>
              <Link to=''>
                <img src={innvoicesIcon} alt='Invoices' />
                <span>Invoices</span>
              </Link>
            </div>
            <div className='menu-link'>
              <Link to=''>
                <img src={cashflowsIcon} alt='Cashflows' />
                <span>Cashflows</span>
              </Link>
            </div>
            <div className='menu-link'>
              <Link to=''>
                <img src={reportsIcon} alt='Reports' />
                <span>Reports</span>
              </Link>
            </div>
            <div className='menu-link'>
              <Link to=''>
                <img src={settingIcon} alt='Settings' />
                <span>Settings</span>
              </Link>
            </div>
          </Paper>
        </div>
      </Drawer>
    </div>
  );

}
export default (MobileHeader)
